export default {
  visibilityState: null,
}
